"use client"

import Image from "next/image"
import { ReactNode } from "react"
import { User } from "@medusajs/icons"
import { useFrontendPreferences } from "@lib/frontend-preferences"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import SideMenu from "@modules/layout/components/side-menu"
import {
  FrontendLanguageSwitcher,
  FrontendThemeToggle,
} from "@modules/layout/components/frontend-preference-controls"

type ClientNavProps = { children: ReactNode }

export default function ClientNav({ children }: ClientNavProps) {
  const { t } = useFrontendPreferences()

  return (
    <div className="sticky top-0 inset-x-0 z-50 group">
      <header className="sahil-source-nav relative mx-auto duration-200">
        <nav className="content-container txt-xsmall-plus flex items-center justify-between w-full h-full text-small-regular">
          <div className="flex-1 basis-0 h-full flex items-center gap-x-7">
            <div className="h-full">
              <SideMenu />
            </div>
            <div className="hidden medium:flex items-center gap-x-5 text-[10px] uppercase tracking-[0.12em] font-semibold">
              <LocalizedClientLink
                href="/store"
                className="sahil-source-nav__link"
              >
                {t.nav.scarves}
              </LocalizedClientLink>
              <LocalizedClientLink
                href="/categories"
                className="sahil-source-nav__link"
              >
                {t.nav.categories}
              </LocalizedClientLink>
              <LocalizedClientLink
                href="/collections"
                className="sahil-source-nav__link"
              >
                {t.nav.collections}
              </LocalizedClientLink>
            </div>
          </div>

          <div className="flex items-center h-full">
            <LocalizedClientLink
              href="/"
              className="sahil-source-nav__brand"
              data-testid="nav-store-link"
              dir="ltr"
            >
              <Image
                src="/assets/sahil/sahil_shell_icon_transparent.png"
                alt=""
                width={43}
                height={43}
                className="sahil-source-nav__icon"
                priority
              />
              <Image
                src="/assets/sahil/sahil_wordmark_transparent.png"
                alt="Sahil"
                width={89}
                height={43}
                className="sahil-source-nav__wordmark"
                priority
              />
            </LocalizedClientLink>
          </div>

          <div className="sahil-nav-utilities flex items-center gap-x-1 medium:gap-x-4 h-full flex-1 basis-0 justify-end">
            <div className="hidden medium:flex items-center gap-x-5 h-full">
              <FrontendLanguageSwitcher />
              <FrontendThemeToggle />
            </div>
            <div className="flex items-center h-full">
              <LocalizedClientLink
                className="sahil-source-nav__link sahil-nav-account"
                href="/account"
                data-testid="nav-account-link"
              >
                <User className="sahil-nav-account__icon" aria-hidden="true" />
                <span className="sahil-nav-account__label">{t.nav.account}</span>
              </LocalizedClientLink>
            </div>
            {children}
          </div>
        </nav>
      </header>
    </div>
  )
}
